export const getHeaderSectionWrapper = () =>
  document.querySelector('#shopify-section-header-v2') ||
  document
    .querySelector('header[data-header-section]')
    ?.closest('.shopify-section') ||
  null;

export const getHeaderSectionHeight = () => {
  const sectionWrapper = getHeaderSectionWrapper();
  if (sectionWrapper) {
    return sectionWrapper.offsetHeight || 0;
  }

  const header = document.querySelector('header[data-header-section]');
  if (header) {
    return header.offsetHeight || 0;
  }

  return 0;
};